/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import Link from "./link"

const Button = ({
  buttonText,
  link,
  linkTarget,
  download,
  style,
  type,
  onClick,
  language,
  seoLinks,
}) => {
  if (link) {
    return (
      <Link
        to={link}
        target={linkTarget}
        download={download}
        language={language}
        seoLinks={seoLinks}
      >
        <button
          sx={{
            variant: "styles.ghostButton",
            px: 4,
            py: 2,
            ...style,
          }}
        >
          {buttonText}
        </button>
      </Link>
    )
  } else {
    return (
      <button
        type={type}
        onClick={onClick}
        sx={{
          variant: "styles.ghostButton",
          px: 4,
          py: 2,
          ...style,
        }}
      >
        {buttonText}
      </button>
    )
  }
}

Button.propTypes = {
  buttonText: PropTypes.string.isRequired,
  link: PropTypes.string,
  linkTarget: PropTypes.string,
  download: PropTypes.bool,
  style: PropTypes.object,
  type: PropTypes.string,
  onClick: PropTypes.func,
  language: PropTypes.oneOf(["", "de", "en"]),
  seoLinks: PropTypes.object,
}

Button.defaultProps = {
  download: false,
  style: {},
  seoLinks: {},
}

export default Button
